import {useEffect} from "react";
import WsConnector from "core/wsConnector";
import {publishEvent} from "core/eventsConnector";

const WebSocketApp = () => {
    useEffect(() => {
        const wsConn = new WsConnector();
        wsConn.setUrl("/ws/app/");
        wsConn.message = (e) => {
            try {
                const data = JSON.parse(e.data);
                const message = data.message || data;
                const type = message.type || data.type;
                if (type) {
                    publishEvent(`app:${type}`, message);
                }
            } catch (err) {
                console.error("[WebSocketApp] Error:", err);
            }
        };
        wsConn.connect();
        return () => {
            wsConn.close();
        };
    }, []);

    return null;
};

export default WebSocketApp;
